import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { RetailerVendorSettingsSchedulerMode } from "../../../api";

export interface SchedulerModeListProps {
  value?: RetailerVendorSettingsSchedulerMode;
  onChange?: (value: RetailerVendorSettingsSchedulerMode) => void;
};

export const SchedulerModeList = (props: SchedulerModeListProps) => {
  const { value: method, onChange } = props;

  const handleChange = (value: string) => {
    if (onChange) onChange(value as RetailerVendorSettingsSchedulerMode);
  };

  return (
    <FormControl>
      <InputLabel id="scheduler-mode-list-label">Scheduler mode</InputLabel>
      <Select labelId="scheduler-mode-list-label" label="Scheduler mode" value={method || RetailerVendorSettingsSchedulerMode.System} onChange={(e) => handleChange(e.target.value)}>
        {Object.keys(RetailerVendorSettingsSchedulerMode).map((item) => {
          return (
            <MenuItem value={item} key={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
